export default {
      id: "scales-usage",
      viewBox: "288 414 20 15",
      url: __webpack_public_path__ + "app/svg/sprite.svg#scales",
      toString: function () {
        return this.url;
      }
    }